import { Input } from 'antd';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

const { Search } = Input;
const SearchFilter = ({
  className = 'w-52',
}: {
  param?: string;
  className?: string | undefined;
  onSearch?: (value: string) => void;
}) => {
  const [searchParams, setSearchParams] = useSearchParams({ search: '' });

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchParams((prev) => {
      prev.set('search', event.target.value);
      return prev;
    });
  };

  return (
    <>
      <Search
        placeholder={'Search'}
        className={className}
        allowClear
        value={searchParams.get('search') || ''}
        onChange={handleInputChange}
      />
    </>
  );
};

export default SearchFilter;
